import React, { useContext } from 'react'
import { Layout } from '../common-templates'
import { Box } from '@mui/material'
import { MediaContext } from '../../util/mediaContext'
import { WarningIcon } from '../../asset'
import { TextBlock } from '../common-templates'
import {
  SECONDARY_ERROR_MESSAGE
  
} from '../../util'

const ErrorBoundary = ({ isError, children }) => {
  let { errorMessage } = useContext(MediaContext)
  if (isError) {
    return (
      <>
        <Layout data='error'>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '2rem',
            }}
          >
              <Box
                sx={{
                  textAlign: 'center',
                }}
              >
                <img src={WarningIcon} />
                <TextBlock
                  variant='h3'
                  text={errorMessage}
                  attributes={{
                    textAlign: 'center',
                    lineHeight: '38px',
                    marginTop: '1rem',
                  }}
                />
                <TextBlock
                  variant='h5'
                  text={
                    localStorage.getItem('Content') === 'Video'
                      ? `${SECONDARY_ERROR_MESSAGE} video.`
                      : `${SECONDARY_ERROR_MESSAGE} photo.`
                  }
                  attributes={{
                    textAlign: 'center',
                    lineHeight: '38px',
                    marginTop: '2rem',
                  }}
                />
              </Box>
          </Box>
        </Layout>
      </>
    )
  } else {
    return children
  }
}

export default ErrorBoundary
